/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebAuthnUserVerification = {
    Discouraged: 'discouraged',
    Preferred: 'preferred',
    Required: 'required'
} as const;
export type WebAuthnUserVerification = typeof WebAuthnUserVerification[keyof typeof WebAuthnUserVerification];


export function WebAuthnUserVerificationFromJSON(json: any): WebAuthnUserVerification {
    return WebAuthnUserVerificationFromJSONTyped(json, false);
}

export function WebAuthnUserVerificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebAuthnUserVerification {
    return json as WebAuthnUserVerification;
}

export function WebAuthnUserVerificationToJSON(value?: WebAuthnUserVerification | null): any {
    return value as any;
}

